import { Component } from '@angular/core';

@Component({
    selector: 'app-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrls: ['./access-denied.component.scss'],
    standalone: false
})
export class AccessDeniedComponent {
  portalSupportLink = 'https://app.smartsheet.com/b/form/3511b90b2c4c4aa383763192c667aba6';
}
